module.exports = __webpack_public_path__ + "media/images/icon-edu-card-gray-9c5ca5d45154e2a70f2beaa0a07076fe.svg";